import * as yup from "yup";

const REQUIRED_FIELD = "Ingrese este campo";
const INVALID_DATE = "Fecha inválida";

export const reportSchema = yup.object().shape({
    from: yup
        .date()
        .required(REQUIRED_FIELD)
        .typeError(INVALID_DATE)
        .max(yup.ref("to"), "La fecha desde no puede ser mayor a la fecha hasta"),
    to: yup.date().required(REQUIRED_FIELD).typeError(INVALID_DATE),
    cutOffDate: yup.date().required(REQUIRED_FIELD).typeError(INVALID_DATE),
});